export const getFirstAndLastName = (fullName?: string | null) => {
  const [firstName, ...lastName] = fullName?.split(" ") ?? ["", ""];
  return [firstName, lastName.join(" ")];
};
